import React from 'react'
import { Accordion } from 'radix-ui'
import { ChevronDownIcon } from '@heroicons/react/24/solid'

export interface AccordionItemProps {
  value: string
  title: string
  titleIcon?: React.ReactNode
  description?: React.ReactNode
  children: React.ReactNode
}

export const AccordionItem: React.FC<AccordionItemProps> = ({
  value,
  title,
  titleIcon,
  description,
  children
}) => {
  return (
    <Accordion.Item
      value={value}
      className="mt-4 bg-white rounded-lg shadow-md overflow-hidden"
    >
      <Accordion.Header className="flex flex-col w-full">
        <Accordion.Trigger className="group cursor-pointer w-full text-left hover:bg-gray-50 transition-colors">
          <div className="flex w-full items-center justify-between p-4">
            <div className="flex justify-start">
              {titleIcon && <div className="mr-1">{titleIcon}</div>}
              <h3 className="text-xl font-semibold text-[#3C2416]">{title}</h3>
            </div>
            <ChevronDownIcon className="h-5 w-5 transform transition-transform duration-200 ease-in-out group-data-[state=open]:rotate-180" />
          </div>
          {description && <div className="px-4 pb-2">{description}</div>}
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content className="overflow-hidden cursor-auto transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
        <div className="p-4 pt-0">{children}</div>
      </Accordion.Content>
    </Accordion.Item>
  )
}
